

























import { Component, Vue } from 'vue-property-decorator';
import MyInput from '@/components/MyInput.vue';
import Button from '@/components/Button.vue';

@Component({
  components: {
    MyInput,
    Button,
  },
})
export default class NewDeck extends Vue {
  private title = '';
  private tagline = '';

  get isAuthorized() {
    return this.$store.state.user !== null && this.$store.state.user.isAdmin;
  }

  private async saveNewDeck() {
    if (!this.isAuthorized) {
      alert('You are not authorized to add a new card to this deck.');
      return;
    }

    const title = this.title.trim();
    const tagline = this.tagline.trim();
    if (title.length === 0 || tagline.length === 0) {
      alert('Please fill in both the title and tagline.');
    } else {
      const deckId = await this.$store.dispatch('ADD_DECK', {
        title,
        tags: tagline.split(',').map((tag) => tag.trim()),
      });
      this.$router.push({
        name: 'manageDeck',
        params: {
          deckId,
        },
      });
    }
  }
}
